import React from 'react';
export function CoreInsight() {
  return <section className="bg-navy-deep py-11 text-ivory-light sm:py-16" aria-labelledby="insight-title" data-id="element-36" data-mp="26nk1g6n4fu7n">
      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-37" data-mp="2hz7kjlyztb4v">
        <h2 id="insight-title" className="font-display text-[24px] font-semibold uppercase leading-[1.1] tracking-tightish sm:text-4xl" data-id="element-38" data-mp="2lzhv7bxqcpq2">
          Your clinical knowledge isn&apos;t the problem.
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-[14.5px] leading-snug text-ivory/75 sm:text-lg" data-id="element-39" data-mp="2vwmg78fuaf5a">
          The problem is having to rebuild the practical resources around that knowledge every
          single time.
        </p>
        <p className="mx-auto mt-6 max-w-md border-t border-ivory/15 pt-6 font-display text-[17px] font-semibold uppercase leading-snug text-gold-light sm:text-xl" data-id="element-40" data-mp="39pvloy0o2gij">
          What if the practical side of your therapy work was already organized?
        </p>
      </div>
    </section>;
}